import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {success,failed} from "../actions/BranchActions";


import {BRANCH_CREATE, BRANCH_LOAD, BRANCH_UPDATE} from "../constants/BranchConst";
import MasterDataService from "../services/MasterDataService";

export function* list() {
    yield takeEvery(BRANCH_LOAD, function* (payload) {
        try {
            const res = yield call(MasterDataService.getBranchList,payload);
            console.log('->>>>>>>>>>');
            yield put(success(res.data.data));
            console.log(res);
        } catch (err) {
            console.log('->>>>>>>>>> error');
            yield put(failed(err));
            console.log(err);
        }
    });
}


export function* create() {
    yield takeEvery(BRANCH_CREATE, function* (payload) {
        try {
            const {data} = payload;
            yield call(MasterDataService.createBranch,data);
            console.log('->>>>>>>>>>');


            const res = yield call(MasterDataService.getBranchList);
            yield put(success(res.data.data));
            console.log(res);
        } catch (err) {
            console.log('->>>>>>>>>> error');
            yield put(failed(err));
            console.log(err);
        }
    });

}
export function* update() {
    yield takeEvery(BRANCH_UPDATE, function* (payload) {
        try {
            const {data} = payload;
            yield call(MasterDataService.editBranch,data.id,data);
            console.log('->>>>>>>>>>');
            const res = yield call(MasterDataService.getBranchList);
            yield put(success(res.data.data));
            console.log(res);
        } catch (err) {
            console.log('->>>>>>>>>> error');
            yield put(failed(err));
            console.log(err);
        }
    });
}


export default function* rootSaga() {
    yield all([
        fork(list),
        fork(create),
        fork(update)
    ]);
}
